/**
 * ZoomLogi Simulator (synthetic courier + sensor) ids and constants.
 * Contract: eng-wiki projects/synthetic-providers/docs/stage1-contract.md.
 */

export const SIM_COURIER_PROVIDER_KEY = 'zlsim';
export const SIM_SENSOR_PROVIDER_KEY = 'zlsim_sensor';
export const SIM_COURIER_TITLE = 'ZoomLogi Simulator';
/** Customer-facing demo key; it only gates the Settings verify step. */
export const SIM_DEMO_API_KEY = 'zlsim-demo-key';
export const SIM_API_KEY_INPUT = 'API Key';

const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const COURIER_ID_PATTERN = /^SIM-\d{6}-\d{6}-[0-9A-HJKMNP-TV-Z]{4}$/;
const SENSOR_ID_PATTERN = /^SIM-\d{6}-\d{6}-[0-9A-HJKMNP-TV-Z]{4}-S\d+$/;

const pad = (value: number): string => String(value).padStart(2, '0');

const randomSuffix = (): string => {
  const bytes = new Uint8Array(4);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => CROCKFORD[b % CROCKFORD.length]).join('');
};

/** `SIM-YYMMDD-HHMMSS-XXXX` in UTC. */
export function generateSimCourierId(now: Date = new Date()): string {
  const date = `${pad(now.getUTCFullYear() % 100)}${pad(now.getUTCMonth() + 1)}${pad(now.getUTCDate())}`;
  const time = `${pad(now.getUTCHours())}${pad(now.getUTCMinutes())}${pad(now.getUTCSeconds())}`;
  return `SIM-${date}-${time}-${randomSuffix()}`;
}

export const simSensorId = (base: string, index: number): string =>
  `${base}-S${index}`;

export const isSimCourierId = (value?: string | null): boolean =>
  !!value && COURIER_ID_PATTERN.test(value.trim());

export const isSimSensorId = (value?: string | null): boolean =>
  !!value && SENSOR_ID_PATTERN.test(value.trim());

export const isSimTrackingId = (value?: string | null): boolean =>
  !!value && /^SIM-/i.test(value.trim());
